import { FranchiseType, LearnerLessonType, Proposition } from "@hubcapp/types";
import { learnerLessonTypeToProductCategoryType } from "@hubcapp/utils";

import {
  FranchiseOption,
  InstructorPrices as InstructorWithPrices,
  LessonPrices,
  PropositionType,
} from "./types";

export const lessonTypeToButtonText = (
  lessonType: LearnerLessonType,
): string => {
  switch (lessonType) {
    case LearnerLessonType.Standard:
      return "Standard";
    case LearnerLessonType.Qualified:
      return "Qualified";
    case LearnerLessonType.PassPlus:
      return "Pass Plus";
    case LearnerLessonType.Motorway:
      return "Motorway";
    case LearnerLessonType.Motability:
      return "Motability";
    case LearnerLessonType.Dit:
      return "DIT";
    default:
      return "";
  }
};

export const getBrandTitle = (
  brand: Proposition["brand"],
  type?: Proposition["type"],
) => {
  if (type && type === FranchiseType.Dit) {
    return "";
  }
  return brand === "AADS" ? "AA" : "BSM";
};

export const getFranchiseTitle = (proposition: Proposition) =>
  `${getBrandTitle(proposition.brand, proposition.type)} ${
    proposition.transmission || ""
  }`.trim();

export const propositionsToFranchiseOptions = (
  propositions: PropositionType[],
): FranchiseOption[] =>
  propositions
    .filter(p => !!p.proposition.type)
    .map(({ id, proposition }: PropositionType) => ({
      id: id,
      name: `${getBrandTitle(proposition.brand)} ${
        proposition.transmission || ""
      }`.trim(),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      type: proposition.type!,
    }));

export const instructorPricesToLessonPrices = (
  instructor?: InstructorWithPrices,
): LessonPrices | null => {
  if (!instructor) {
    return null;
  }

  const learnerLessonTypes = [
    LearnerLessonType.Dit,
    LearnerLessonType.Standard,
    LearnerLessonType.Motability,
    LearnerLessonType.Motorway,
    LearnerLessonType.PassPlus,
    LearnerLessonType.Qualified,
  ];
  return learnerLessonTypes.reduce(
    (lessonPrices, lessonType) => {
      const categoryType = learnerLessonTypeToProductCategoryType(lessonType);

      const price = instructor.prices.find(
        p => p.productCategory === categoryType,
      );
      if (!price) {
        return lessonPrices;
      }

      return {
        ...lessonPrices,
        [lessonType]: price.price,
      };
    },
    {
      [LearnerLessonType.Dit]: null,
      [LearnerLessonType.Standard]: null,
      [LearnerLessonType.Motability]: null,
      [LearnerLessonType.Motorway]: null,
      [LearnerLessonType.PassPlus]: null,
      [LearnerLessonType.Qualified]: null,
    } as LessonPrices,
  );
};

export const isValidPrice = (value: string): boolean =>
  /^\d+(\.\d{0,2})?$/.test(value);
